import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const PromoCodeProtectedRoute = ({ children }) => {
  const { user, loading, hasPromoCode, isAdmin } = useAuth();
  const location = useLocation();

  // 로딩 중이거나 프로모션 코드 확인이 아직 안된 경우
  if (loading || hasPromoCode === null) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // 로그인하지 않은 경우
  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // 관리자이거나 프로모션 코드가 있는 경우 접근 허용
  if (isAdmin || hasPromoCode) {
    return children;
  }

  // 프로모션 코드가 없는 경우 프로필 페이지로 리다이렉트
  return <Navigate to="/profile" state={{ from: location, needPromoCode: true }} replace />;
};

export default PromoCodeProtectedRoute;
